/* HOMELUX Produktseite — Galerie, Varianten, Menge, Beschreibung. Vanilla JS. */
(function () {
  'use strict';

  /* Jede Initialisierung darf pro Element nur EINMAL laufen.
     Das Script wird von mehreren Sections eingebunden und daher mehrfach
     ausgeführt — ohne diese Sperre würden sich Klick-Listener aufaddieren
     (Menge sprang dann um +2, +3 ... statt um 1). */
  function once(el, key) {
    if (!el || el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------------- Galerie ---------------- */
  function initGallery(root) {
    if (!once(root, 'hlGalleryReady')) return;
    var slides = root.querySelectorAll('[data-hl-slide]');
    var thumbs = root.querySelectorAll('[data-hl-thumb]');
    var strip = root.querySelector('[data-hl-thumbs]');
    var stage = root.querySelector('[data-hl-gallery] .hl-gallery__stage');
    var dotsWrap = root.querySelector('[data-hl-gallery-dots]');
    var n = slides.length;

    function markActive(index) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.hlSlide === String(index)); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.hlThumb === String(index)); });
      if (dotsWrap) {
        dotsWrap.querySelectorAll('button').forEach(function (b, i) {
          b.classList.toggle('is-active', i === index);
        });
      }
    }

    function show(index) {
      index = (index + n) % n;
      markActive(index);
      var active = root.querySelector('[data-hl-thumb="' + index + '"]');
      if (active && strip) {
        var left = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
        strip.scrollTo({ left: left, behavior: 'smooth' });
      }
      if (stage && stage.scrollWidth > stage.clientWidth) {
        stage.scrollTo({ left: index * stage.clientWidth, behavior: 'smooth' });
      }
    }

    // Dots aufbauen
    if (dotsWrap && n > 1) {
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Bild ' + (i + 1));
        d.addEventListener('click', (function (idx) { return function () { show(idx); }; })(i));
        dotsWrap.appendChild(d);
      }
      markActive(0);
    }

    // Wisch-Sync (mobil): active Folie aus Scrollposition ableiten
    if (stage) {
      stage.addEventListener('scroll', function () {
        if (stage.scrollWidth <= stage.clientWidth) return;
        var idx = Math.round(stage.scrollLeft / stage.clientWidth);
        markActive(Math.min(n - 1, Math.max(0, idx)));
      }, { passive: true });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.hlThumb, 10)); });
    });

    var prev = root.querySelector('[data-hl-thumb-prev]');
    var next = root.querySelector('[data-hl-thumb-next]');
    function step(dir) {
      var current = root.querySelector('[data-hl-slide].is-active');
      var i = current ? parseInt(current.dataset.hlSlide, 10) : 0;
      show((i + dir + n) % n);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    root.hlShowMedia = show;

    /* --- Lupe (Desktop): nur der Bereich unter der Maus wird groß --- */
    var stageEl = stage || root.querySelector('.hl-gallery__stage');
    if (stageEl && window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      var zoomingSlide = null;
      function applyZoom(e) {
        var slide = stageEl.querySelector('.hl-gallery__slide.is-active');
        var img = slide ? slide.querySelector('img') : null;
        if (!slide || !img) return;
        if (slide !== zoomingSlide) { slide.classList.add('is-zooming'); if (zoomingSlide) zoomingSlide.classList.remove('is-zooming'); zoomingSlide = slide; }
        var r = slide.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      }
      function clearZoom() {
        if (zoomingSlide) { zoomingSlide.classList.remove('is-zooming'); zoomingSlide = null; }
      }
      stageEl.addEventListener('mousemove', applyZoom);
      stageEl.addEventListener('mouseleave', clearZoom);
    }

    /* --- Lightbox (Mobile/Vollbild): Tippen aufs Bild --- */
    (function () {
      var lb = document.querySelector('.hl-lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'hl-lightbox';
        lb.innerHTML = '<button type="button" class="hl-lightbox__close" aria-label="Schließen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button><div class="hl-lightbox__img"></div><div class="hl-lightbox__thumbs" data-hl-lb-thumbs></div>';
        document.body.appendChild(lb);
      }
      var lbImg = lb.querySelector('.hl-lightbox__img');
      var close = lb.querySelector('.hl-lightbox__close');
      var thumbsWrap = lb.querySelector('[data-hl-lb-thumbs]');
      function show(index) {
        var slide = slides[index];
        var img = slide ? slide.querySelector('img') : null;
        if (!img) return;
        lbImg.innerHTML = '<img src="' + (img.currentSrc || img.src) + '" alt="">';
        thumbsWrap.querySelectorAll('button').forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
        var active = thumbsWrap.querySelector('.is-active');
        if (active && typeof active.scrollIntoView === 'function') active.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
      function open() {
        thumbsWrap.innerHTML = '';
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('img');
          if (!img) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Bild ' + (i + 1));
          b.innerHTML = '<img src="' + (img.currentSrc || img.src) + '" alt="" loading="lazy">';
          b.addEventListener('click', function () { show(i); });
          thumbsWrap.appendChild(b);
        });
        var current = root.querySelector('.hl-gallery__slide.is-active');
        var idx = current ? parseInt(current.dataset.hlSlide, 10) : 0;
        show(idx);
        lb.classList.add('is-open');
        document.body.classList.add('hl-lightbox-open');
      }
      function closeLb() {
        lb.classList.remove('is-open');
        document.body.classList.remove('hl-lightbox-open');
      }
      slides.forEach(function (s) { s.addEventListener('click', open); });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg || e.target === close) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
      root.hlCloseLightbox = closeLb;
    })();
  }

  /* ---------------- Varianten ---------------- */
  function initVariants(root) {
    var dataEl = root.querySelector('[data-hl-variant-data]');
    if (!dataEl) return;
    if (!once(root, 'hlVariantsReady')) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = (data && data.variants) || [];

    var idInput = root.querySelector('[data-hl-variant-id]');
    var priceEl = root.querySelector('[data-hl-price]');
    var compareEl = root.querySelector('[data-hl-compare]');
    var saveEl = root.querySelector('[data-hl-save]');
    var stockEl = root.querySelector('[data-hl-stock]');
    var soldoutEl = root.querySelector('[data-hl-soldout]');
    var addBtn = root.querySelector('[data-hl-add]');
    var addText = root.querySelector('[data-hl-add-text]');
    var gallery = root.querySelector('[data-hl-gallery]');

    var labels = addBtn ? {
      available: addBtn.dataset.available || 'In den Warenkorb',
      soldout: addBtn.dataset.soldout || 'Ausverkauft'
    } : null;

    function selected() {
      var values = [];
      root.querySelectorAll('.hl-variants__input:checked').forEach(function (input) {
        values[parseInt(input.dataset.hlOption, 10)] = input.value;
      });
      return values;
    }

    function match(values) {
      return variants.filter(function (v) {
        return values.every(function (val, i) { return val === undefined || v.options[i] === val; });
      })[0];
    }

    function update() {
      var v = match(selected());
      if (!v) return;

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;

      if (compareEl) {
        compareEl.textContent = v.compare_at_price || '';
        compareEl.hidden = !v.on_sale;
      }
      if (saveEl) saveEl.hidden = !v.on_sale;

      // "Auf Lager" nur bei echter Verfügbarkeit
      if (stockEl) stockEl.hidden = !v.available;
      if (soldoutEl) soldoutEl.hidden = !!v.available;

      // "Nur noch wenige auf Lager"
      var lowEl = root.querySelector('[data-hl-low-stock]');
      if (lowEl) {
        var threshold = parseInt(lowEl.getAttribute('data-threshold'), 10) || 3;
        var qty = v.inventory_quantity;
        lowEl.hidden = !(v.available && qty != null && qty > 0 && qty <= threshold);
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText && labels) addText.textContent = v.available ? labels.available : labels.soldout;
      }

      // Sticky Mobile-Leiste synchron halten
      var barPrice = document.querySelector('[data-hl-price-bar]');
      if (barPrice) barPrice.textContent = v.price;
      var barBtn = document.querySelector('[data-hl-add-bar]');
      if (barBtn) {
        barBtn.disabled = !v.available;
        var barLabels = barBtn.closest('[data-hl-stickybuy]');
        var avail = barLabels ? barLabels.dataset.available : 'In den Warenkorb';
        var soldout = barLabels ? barLabels.dataset.soldout : 'Ausverkauft';
        barBtn.textContent = v.available ? avail : soldout;
      }

      if (v.media_position && gallery && typeof gallery.hlShowMedia === 'function') {
        gallery.hlShowMedia(v.media_position - 1);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      root.dispatchEvent(new CustomEvent('hl:variant:change', { detail: v, bubbles: true }));
    }

    root.querySelectorAll('.hl-variants__input').forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  /* ---------------- Menge ---------------- */
  function initQuantity(root) {
    var input = root.querySelector('[data-hl-qty-input]');
    if (!input) return;
    root.querySelectorAll('[data-hl-qty]').forEach(function (btn) {
      if (!once(btn, 'hlQtyReady')) return;
      btn.addEventListener('click', function () {
        var step = parseInt(btn.dataset.hlQty, 10) || 1;
        var value = (parseInt(input.value, 10) || 1) + step;
        input.value = Math.max(parseInt(input.min, 10) || 1, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------------- Beschreibung ein-/ausklappen ---------------- */
  function initDescription(scope) {
    scope.querySelectorAll('[data-hl-desc]').forEach(function (desc) {
      if (!once(desc, 'hlDescReady')) return;
      var body = desc.querySelector('[data-hl-desc-body]');
      // Umschalter nur nötig, wenn der Text tatsächlich länger ist
      var max = parseInt(getComputedStyle(desc).getPropertyValue('--hl-desc-max'), 10) || 240;
      if (body && body.scrollHeight <= max) {
        desc.classList.remove('is-collapsed');
        desc.classList.add('is-short');
      }
      desc.querySelectorAll('[data-hl-desc-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () { desc.classList.toggle('is-collapsed'); });
      });
    });
  }

  function boot(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hl-product]').forEach(function (root) {
      var gallery = root.querySelector('[data-hl-gallery]');
      if (gallery) initGallery(gallery);
      initVariants(root);
      initQuantity(root);
    });
    initDescription(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
